import React from "react";
import { Table, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import { formatDateTime } from "../../helpers/date";

const statusDesc = {
  Delivery: "Successfully delivered the email to the recipient's mail server",
  Complaint:
    "Successfully delivered to the recipient’s mail server, but the recipient marked it as spam",
  Bounce: "Recipient's mail server permanently rejected the email",
};

const EmailList = (props) => {
  const columns = [
    {
      title: "Status",
      dataIndex: "type",
      width: 110,
      render: (status) => {
        return (
          <>
            {status}
            {` `}
            <Tooltip title={statusDesc[status] || status}>
              <InfoCircleOutlined />
            </Tooltip>
          </>
        );
      },
    },
    { title: "Sender", dataIndex: ["sentFrom"], width: 200 },
    { title: "Recipient", dataIndex: ["sentTo"], width: 200 },
    { title: "Subject", dataIndex: "subject" },
    {
      title: "Event At",
      dataIndex: "_created_at",
      width: 130,
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
  ];

  return (
    <div className="table">
      <Table
        rowKey="objectId"
        className="table-section"
        columns={columns}
        dataSource={props.emails}
        pagination={false}
        scroll={{ x: 1100, y: 500 }}
      />
    </div>
  );
};

export default EmailList;
